export const getForcedTreatmentForTesting = () => {
  try {
    const localStorageItem = localStorage.getItem(
      'forceExperimentationExitIntentLayer'
    );
    if (localStorageItem === 'Default' || localStorageItem === 'Picture') {
      return localStorageItem;
    }
  } catch {
    // 🤷‍♂️
  }
  return null;
};
